import React from 'react';
import * as Yup from "yup";
import { sortCaret } from "../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { DatePickerField, Input } from "../../../../_metronic/_partials/controls";
import { SelectObjectsField } from '../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField';
import { SelectStatus } from '../../customComponents/SelectStatus';
import ModalSearchField from '../../../../_metronic/_partials/controls/forms/ModalSearchField';
import { FilterSelectObjectsField } from '../../../../_metronic/layout/components/basePage/selectObjects/FilterSelectObjectsField';

export const initObject = {
  id: undefined,
  title: "",
  code: "",
  categoryId: null,
  categoryTitle: "",
  placeId: 0,
  placeTitle: "",
  provienceTitle: "",
  townTitle: "",
  floorsCount: "",
  rooms: [],
  roomsCount: "",
  useDate: "",
  repairDate: "",
  isDeleted: false
};

export const columns = [
  // {
  //   dataField: "provienceTitle",
  //   text: "استان",
  //   sort: false,
  //   sortCaret: sortCaret,
  // },
  // {
  //   dataField: "townTitle",
  //   text: "استان/شهرستان",
  //   sort: false,
  //   sortCaret: sortCaret,
  // },
  {
    dataField: "placeTitle",
    text: "پردیس/مرکز - استان/شهرستان",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "title",
    text: "نام بلوک",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "code",
    text: "کد",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "categoryTitle",
    text: "کاربری",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "floorsCount",
    text: "تعداد طبقه",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "roomsCount",
    text: "تعداد اتاق",
    sort: false,
    sortCaret: sortCaret,
    formatter: (cell, row) => {
      var count = 0
      row.rooms.forEach(floor => {
        floor.forEach(room => {
          if (room.isDeleted === false)
            count++;
        });
      });
      return count
    }
  },
  {
    dataField: "useDate",
    text: "تاریخ بهره برداری",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.DateColumnFormatter,
  },
  {
    dataField: "repairDate",
    text: "تاریخ آخرین تعمیر و تجهیز",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.DateColumnFormatter,
  },
  {
    dataField: "isDeleted",
    text: "وضعیت",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.StatusColumnFormatter,
  },
  // {
  //   dataField: "action",
  //   text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
  //   // text: "Actions",
  //   formatter: columnFormatters.ActionsColumnFormatter,
  //   formatExtraData: {
  //     // openEditObjectPage: objectsUIProps.openEditObjectPage,
  //     // openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
  //   },
  //   classes: "text-right pr-0",
  //   headerClasses: "text-right pr-3",
  //   style: {
  //     minWidth: "100px",
  //   },
  // },
];

export const formFields = [
  {
    row: 1,
    list: [
      {
        name: "placeId",
        type: "option",
        component: (props) =>
          <FilterSelectObjectsField
            api="api/place"
            reduxState="places"
            sname="placeId"
            valueFieldNames="fullTitle"
            label="پردیس / مرکز"
            useInFilter={false}
            {...props}
          />,
        placeholder: "پردیس / مرکز",
        label: "پردیس / مرکز",
        rowIdx: 1,
        class: "col-lg-4",
      },
      {
        name: "title",
        type: "text",
        component: Input,
        placeholder: "نام بلوک",
        label: "نام بلوک",
        rowIdx: 2,
        class: "col-lg-4"
      },
      {
        name: "code",
        type: "text",
        component: Input,
        placeholder: "کد",
        label: "کد",
        rowIdx: 3,
        class: "col-lg-4"
      },

      // {
      //   name: "categoryId",
      //   type: "text",
      //   component: (props) => <SelectObjectsField api="api/category"
      //     reduxState="buildingCategories"
      //     sname="categoryId"
      //     label="کاربری" {...props} />,
      //   placeholder: "کاربری",
      //   label: "کاربری",
      //   rowIdx: 3,
      //   class: "col-lg-4"
      // },
    ]
  },
  {
    row: 2,
    list: [

      {
        name: "categoryId",
        type: "text",
        component: (props) => <SelectObjectsField api="api/category"
          reduxState="roomCategories"
          sname="categoryId"
          label="کاربری" {...props} />,
        placeholder: "کاربری",
        label: "کاربری",
        rowIdx: 3,
        class: "col-lg-4"
      },
      {
        name: "useDate",
        type: "date",
        component: DatePickerField,
        placeholder: "تاریخ بهره برداری",
        label: "تاریخ بهره برداری",
        rowIdx: 4,
        class: "col-lg-4"
      },
      {
        name: "repairDate",
        type: "date",
        component: DatePickerField,
        placeholder: "تاریخ تعمیر و تجهیز",
        label: "تاریخ تعمیر و تجهیز",
        rowIdx: 5,
        class: "col-lg-4"
      }
    ]
  },

];

export const otherFields = [
  // {
  //   name: "description",
  //   lable: "Description",
  //   type: "textarea",
  //   as: "textarea",
  //   rowOrder: 1,
  //   rowIdx: 1,
  //   class: "form-control"
  // },

];

export const columnsSearch = [
  {
    dataField: "title",
    text: "عنوان",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "code",
    text: "کد",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "categoryTitle",
    text: "کاربری",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "genderCategoryTitle",
    text: "جنسیت",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "townTitle",
    text: "شهرستان",
    sort: true,
    sortCaret: sortCaret,
  },
];

export const filterFields = [
  {
    name: "placeId",
    lable: "پردیس / مرکز",
    type: "searchComponent",
    list: [],
    component: (props) =>
      <FilterSelectObjectsField
        api="api/place"
        reduxState="places"
        sname="placeId"
        valueFieldNames="fullTitle"
        {...props} />
  },
  // {
  //   name: "placeId",
  //   label: "پردیس / مرکز",
  //   type: "search",
  //   list: [],
  //   rowIdx: 11,
  //   placeholder: "پردیس / مرکز",
  //   baseplaceholder: "پردیس / مرکز",
  //   component: (props) => (
  //     <ModalSearchField
  //       api="api/place"
  //       reduxState="places"
  //       filterFields={["title", "genderCategoryTitle", "categoryTitle", "townTitle"]}
  //       fieldName="id"
  //       columns={columnsSearch}
  //       {...props}
  //     />
  //   ),
  // },


  {
    name: "isDeleted",
    lable: "MODULES.GENERAL.STATUS",
    type: "select",
    list: [
      {
        value: "",
        lable: "MODULES.GENERAL.STATUSALL",
      },
      {
        value: "0",
        lable: "MODULES.GENERAL.STATUSENABLE",
      },
      {
        value: "1",
        lable: "MODULES.GENERAL.STATUSDELETED",
      },

    ],
    component: SelectStatus
  },
  // {
  //   name: "categoryId",
  //   lable: "کاربری",
  //   type: "component",
  //   list: [],
  //   component: (props) =>
  //     <SelectObjectsField api="api/category"
  //       reduxState="buildingCategories"
  //       sname="categoryId"
  //       {...props} />
  // },

  {
    name: "searchText",
    lable: "عنوان بلوک",
    type: "text",
    list: [],
  },

];

export const filterInitialValues = {
  filter: {
    isDeleted: "", // values => All=""/Selling=0/Sold=1
    searchText: "",
    placeId: 0
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10,

  whereClause: "",
  whereClauseParameters: [
  ],
  orderClause: "id desc ",
  skipCount: 0,
  takeCount: 10,
};
export const prepareFilter = (queryParams, values) => {
  const { isDeleted, searchText, placeId } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by isDeleted
  if (isDeleted !== undefined)
    filter.isDeleted = isDeleted !== "" ? +isDeleted : undefined;


  filter.placeId = placeId !== "" ? +placeId : 0;
  // Filter by all fields
  filter.searchText = searchText;
  if (searchText) {
    filter.searchText = searchText;
  }
  newQueryParams.filter = filter;

  let whereClause = ""
  const whereClauseParameters = [];

  var idx = 0;

  if (searchText !== "" && searchText !== undefined && idx === 0) {
    whereClause = `title.contains(@${idx})`
    whereClauseParameters.push(searchText)
    idx++;
  }
  else if (searchText !== "" && searchText !== undefined && idx > 0) {
    whereClause = whereClause + ` and title.contains(@${idx})`
    whereClauseParameters.push(searchText)
    idx++;
  }

  if (filter.placeId > 0 && idx === 0) {
    whereClause = `placeId=@${idx}`
    whereClauseParameters.push(filter.placeId)
    idx++;
  }
  else if (filter.placeId > 0 && idx > 0) {
    whereClause = whereClause + ` and placeId=@${idx}`
    whereClauseParameters.push(filter.placeId)
    idx++;
  }

  if (filter.isDeleted !== undefined && idx === 0) {
    whereClause = "isDeleted=@0";
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
    idx++;
  }
  else if (filter.isDeleted !== undefined && idx > 0) {
    whereClause = whereClause + ` and isDeleted=@${idx}`
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
    idx++;
  }

  newQueryParams.whereClause = whereClause;
  newQueryParams.whereClauseParameters = whereClauseParameters;

  return newQueryParams;
};


// Validation schema
export const ObjectEditSchema = Yup.object().shape({
  title: Yup.string()
    .required("پر کردن فیلد الزامی است"),
  categoryId: Yup.number()
    .positive("پر کردن فیلد الزامی است"),
});

